import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_COOP_TRANSACTIONS_SUMMARY } from "../../../config/api";

export const getCoopTransactionsSummary = createAsyncThunk(
  "coopTransactions/getSummary",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "GET",
        path: API_COOP_TRANSACTIONS_SUMMARY,
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);
